import React, { type ReactNode, useMemo } from "react";
import styles from "./context-menu-content.module.css";
import { useContextMenu } from "./hooks";

export type ContextMenuContentProps = {
  children?: ReactNode;
  variant?: string;
  as?: any;
} & React.AllHTMLAttributes<HTMLDivElement>;

export function ContextMenuContent({
  children,
  variant,
  as = "div",
  ...props
}: ContextMenuContentProps) {
  const { isOpen } = useContextMenu();

  const validateClassName = useMemo(() => {
    const variantType =
      variant === "secondary" ? `${styles.Variant}` : `${styles.Content}`;
    if (isOpen) {
      return `${variantType} ${styles.IsOpen}`;
    }

    return `${variantType} ${styles.IsClosed}`;
  }, [isOpen, variant]);

  return React.createElement(
    as,
    {
      className: validateClassName,
      ...props,
    },
    children
  );
}
